// Uygulama genelindeki .env tabanlı ayarların tek okuma noktası.
// Vite env değişkenleri her zaman string olduğundan boolean'a çeviriyoruz.

const asBool = (value: string | undefined, fallback: boolean): boolean => {
  if (value === undefined) return fallback;
  return value.trim().toLowerCase() === 'true';
};

// Google reCAPTCHA
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? '';
// Var yoksa güvenli taraf: açık kabul et
export const RECAPTCHA_ENABLED = asBool(import.meta.env.VITE_RECAPTCHA_ENABLED, true);

// WebView / masaüstü wrapper engelleme.
// Var yoksa kapalı kabul et (yanlış yapılandırmada kullanıcıları kilitlememek için).
export const WEBVIEW_GUARD_ENABLED = asBool(import.meta.env.VITE_WEBVIEW_GUARD_ENABLED, false);
